import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalConfig } from '../../../js/interfaces/CoverpathTypes';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalSubject = new Subject();
  private responseSubject = new Subject();
  modalType = this.modalSubject.asObservable();
  userResponse = this.responseSubject.asObservable();

  activate(modalData: ModalConfig) {
    this.modalSubject.next(modalData);
  }

  // close modal
  deactivate() {
    this.modalSubject.next(null);
  }

  // close modal and send user response;
  response(event) {
    this.modalSubject.next(null);
    this.responseSubject.next(event);
  }
}
